export var TemplateNamesEnum;
(function (TemplateNamesEnum) {
    TemplateNamesEnum["WITHOUT_TEMPLATE"] = "WITHOUT_TEMPLATE";
    TemplateNamesEnum["STANDARD_FIRST"] = "STANDARD_FIRST";
    TemplateNamesEnum["STANDARD_SECOND"] = "STANDARD_SECOND";
})(TemplateNamesEnum || (TemplateNamesEnum = {}));
